import { render, staticRenderFns } from "./QrShortcutDialog.vue?vue&type=template&id=5f28059c&scoped=true"
import script from "./QrShortcutDialog.vue?vue&type=script&lang=js"
export * from "./QrShortcutDialog.vue?vue&type=script&lang=js"
import style0 from "./QrShortcutDialog.vue?vue&type=style&index=0&id=5f28059c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28059c",
  null
  
)

export default component.exports